import { createStore, useStore } from 'zustand';
import { persist } from 'zustand/middleware';
const isInSandbox = () => {
  try {
    return window.location.pathname.startsWith('/collaboration-sidebar-sandbox-ui');
  } catch (_unused) {
    return false;
  }
};

// magpie-lib reads MAGPIE_DEBUG_ALL directly from localStorage,
// so we sync this flag to its well-known key separately.
const MAGPIE_DEBUG_KEY = 'MAGPIE_DEBUG_ALL';
const getMagpieDebug = () => {
  try {
    return localStorage.getItem(MAGPIE_DEBUG_KEY) === 'true';
  } catch (_unused2) {
    return false;
  }
};
const setMagpieDebug = value => {
  try {
    if (value) {
      localStorage.setItem(MAGPIE_DEBUG_KEY, 'true');
    } else {
      localStorage.removeItem(MAGPIE_DEBUG_KEY);
    }
  } catch (_unused3) {
    // localStorage may be unavailable
  }
};
export const devtoolsFlagsStore = createStore()(persist(set => ({
  ablyLogging: false,
  leaderFollowerValidation: false,
  magpieDebug: getMagpieDebug(),
  previewPostMessageLogging: false,
  useLocalSidebar: isInSandbox(),
  toggleAblyLogging: () => set(state => ({
    ablyLogging: !state.ablyLogging
  })),
  toggleLeaderFollowerValidation: () => set(state => ({
    leaderFollowerValidation: !state.leaderFollowerValidation
  })),
  toggleMagpieDebug: () => set(state => {
    const next = !state.magpieDebug;
    setMagpieDebug(next);
    return {
      magpieDebug: next
    };
  }),
  togglePreviewPostMessageLogging: () => set(state => ({
    previewPostMessageLogging: !state.previewPostMessageLogging
  })),
  toggleUseLocalSidebar: () => set(state => ({
    useLocalSidebar: !state.useLocalSidebar
  }))
}), {
  name: 'collab-sidebar-devtools-flags',
  partialize: ({
    ablyLogging,
    leaderFollowerValidation,
    previewPostMessageLogging,
    useLocalSidebar
  }) => ({
    ablyLogging,
    leaderFollowerValidation,
    previewPostMessageLogging,
    useLocalSidebar
  })
}));

// Non-React accessor for use in sync strategies and similar
export const devtoolsFlags = {
  get ablyLogging() {
    return devtoolsFlagsStore.getState().ablyLogging;
  },
  get leaderFollowerValidation() {
    return devtoolsFlagsStore.getState().leaderFollowerValidation;
  },
  get previewPostMessageLogging() {
    return devtoolsFlagsStore.getState().previewPostMessageLogging;
  },
  get useLocalSidebar() {
    return devtoolsFlagsStore.getState().useLocalSidebar;
  }
};
export function useDevtoolsFlags() {
  return useStore(devtoolsFlagsStore);
}